import Street from "../assets/svg/ic-streetads.svg";
import School from "../assets/svg/ic-school.svg";
import ShoppingMall from "../assets/svg/ic-shopping-malls.svg";
import Airport from "../assets/svg/ic-airport.svg";
import Banks from "../assets/svg/ic-banks.svg";
import Concerts from "../assets/svg/ic-concerts.svg";
import Mrt from "../assets/svg/ic-mrt.svg";
import Office from "../assets/svg/ic-office.svg";
import Restaurant from "../assets/svg/ic-restaurants.svg";
import Supermarket from "../assets/svg/ic-supermarket.svg";
import Wedding from "../assets/svg/ic-wedding.svg";
import Led from "../assets/svg/ic-led.svg";

import central from  "../assets/svg/icon_central.svg";
import compatibility from  "../assets/svg/icon_compatibility.svg";
import cost from  "../assets/svg/icon_cost.svg";
import instant from  "../assets/svg/icon_instant.svg";
import online from  "../assets/svg/icon_online.svg";
import setup from  "../assets/svg/icon_setup.svg";
import support from  "../assets/svg/icon_support.svg";
import security from  "../assets/svg/icon_security.svg";
import monitoring from '../assets/svg/icon_monitoring.svg'

import apps from '../assets/svg/icon_apps.svg'
import interactive from '../assets/svg/icon_interactive.svg'
import supportBlue from '../assets/svg/icon_support_blue.svg'
import update from '../assets/svg/icon_update.svg'
import warranty from '../assets/svg/icon_warranty.svg'

export {
  Street,
  School,
  ShoppingMall,
  Airport,
  Banks,
  Concerts,
  Mrt,
  Office,
  Restaurant,
  Supermarket,
  Wedding,
  Led,
  central,
  compatibility,
  cost,
  instant,
  online,
  setup,
  support,
  security,
  monitoring,
  apps,
  interactive,
  supportBlue,
  update,
  warranty
};


// WEBPACK FOOTER //
// ./src/components/SvgAssets.js